import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AiSummary from 'bundles/apex/deals/show/ai_summary';
import Cards from 'bundles/apex/card/container';
import CustomFields from './cards/custom_fields';
import Deal from './cards/deal';
import Financials from './cards/financials';
import InternalBrokers from 'bundles/apex/deals/show/brokers/internal';
import LeaseTerms from './cards/lease_terms';
import OutsideBrokers from 'bundles/apex/deals/show/brokers/outside';
import Property from './cards/property';
import TransactionSide from './cards/transaction_side';
import { BUY_SIDE, SELL_SIDE } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

import './styles.scss';

export function OverviewView({ deal }) {
  return (
    <React.Fragment>
      <Cards>
        <Deal />
        <div className="apex-card full-width">
          <AiSummary />
        </div>
        {
          !deal.hasTransactionSides && (
            <React.Fragment>
              <InternalBrokers />
              <OutsideBrokers />
            </React.Fragment>
          )
        }
        <Property />
        <Financials />
        {
          !!deal.hasTransactionSides && (
            <React.Fragment>
              <TransactionSide transactionSide={SELL_SIDE} />
              <TransactionSide transactionSide={BUY_SIDE} />
            </React.Fragment>
          )
        }
        <LeaseTerms />
        <CustomFields />
      </Cards>
    </React.Fragment>
  );
}

OverviewView.propTypes = {
  deal: PropTypes.shape({
    transactionSideDetails: PropTypes.array,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(OverviewView);
